import * as tooltips from "./tooltips";
import GeoJSONPointsCollection from "../../../../components/maps/GeoJSONMap/GeoJSONPointsCollection";
import React from "react";
import * as markers from "./markers";


const StationsLayer = ({webgis}) => {
    const {featuresState} = webgis;
    const {
        stationGeoJSON,
        stationSelectedState,
        contrastColorsHash
    } = featuresState;

    const defaultColor = "#1e88e5"
    const textColor = contrastColorsHash[defaultColor] ?? '#ffffff';

    const stationMarkerIconFn = (feature) => {
        return markers.stationMarker({feature, colorCode: defaultColor, textColor});
    }

    const stationClusterIconFn = (cluster) => {
        return markers.stationCluster({cluster, colorCode: defaultColor, textColor});
    }

    const stationsClusterGroupKey = `stationsClusterGroup-${stationGeoJSON?.features?.length}-${featuresState.geoStationsQuery?.dataUpdatedAt}`;

    return <GeoJSONPointsCollection featureCollection={stationGeoJSON}
                                    cluster
                                    getSelectedFeatures={stationSelectedState.getSelectedFeatures}
                                    onFeatureClick={webgis.handleStationClick}
                                    renderFeatureTooltip={tooltips.renderStationTooltip}
                                    markerIconFn={stationMarkerIconFn}
                                    clusterIconFn={stationClusterIconFn}
                                    clusterGroupProps={{key: stationsClusterGroupKey}}/>
}

export default StationsLayer;